export type SchemaKind =
  | "organization"
  | "website"
  | "faq"
  | "collection"
  | "webpage"
  | "breadcrumbs";

export interface SchemaDescriptor {
  kind: SchemaKind;
}

export interface RouteMeta {
  title: string;
  description: string;
  keywords: string;
  canonicalPath?: string;
  robots?: string;
  ogType?: "website" | "article";
  schema?: SchemaDescriptor[];
}

export const siteName = "智选志愿";
export const siteUrl = "https://gaokao.traeai.com";

export const defaultRouteMeta: RouteMeta = {
  title: "AI智能志愿填报 — 精准避坑，科学择校",
  description: "智选志愿是面向高考考生和家长的AI志愿填报辅助平台，提供院校专业查询、分数位次分析、AI答疑、资讯和入学指南。",
  keywords: "高考志愿填报,AI志愿填报,院校查询,专业查询,分数线查询,高考资讯",
  canonicalPath: "/",
  robots: "index,follow",
  ogType: "website",
  schema: [{ kind: "organization" }, { kind: "website" }, { kind: "webpage" }],
};

export const routeMeta: Record<string, RouteMeta> = {
  "/": defaultRouteMeta,
  "/ai-fill": {
    title: "AI智能填报 — 生成冲稳保志愿方案",
    description: "输入省份、科类、分数和位次，AI自动生成冲刺、稳妥、保底、兜底四层志愿方案并提示风险。",
    keywords: "AI填报,冲稳保,志愿方案,高考位次,录取概率",
    canonicalPath: "/ai-fill",
    robots: "index,follow",
    ogType: "website",
    schema: [{ kind: "webpage" }, { kind: "breadcrumbs" }],
  },
  "/ai-qa": {
    title: "雪峰志愿顾问 — 会追问的高考志愿咨询",
    description: "围绕省份、位次、选科、家庭资源和就业诉求进行追问式高考志愿咨询，辅助判断院校专业方向。",
    keywords: "雪峰志愿顾问,AI答疑,高考问答,志愿咨询,填报技巧",
    canonicalPath: "/ai-qa",
    robots: "index,follow",
    ogType: "website",
    schema: [{ kind: "webpage" }, { kind: "breadcrumbs" }],
  },
  "/data/universities": {
    title: "院校数据库 — 查询高校层次、城市和专业优势",
    description: "查询热门高校、院校层次、城市位置、办学类型和特色标签，辅助高考志愿择校。",
    keywords: "院校数据库,大学查询,985,211,双一流,高校排名",
    canonicalPath: "/data/universities",
    robots: "index,follow",
    ogType: "website",
    schema: [{ kind: "collection" }, { kind: "breadcrumbs" }],
  },
  "/data/majors": {
    title: "专业数据库 — 查询专业方向、就业和薪资",
    description: "了解热门专业门类、培养方向、就业率、薪资区间和未来发展，帮助考生科学选专业。",
    keywords: "专业数据库,专业查询,热门专业,就业率,薪资",
    canonicalPath: "/data/majors",
    robots: "index,follow",
    ogType: "website",
    schema: [{ kind: "collection" }, { kind: "breadcrumbs" }],
  },
  "/data/scores": {
    title: "分数线查询 — 历年分数与位次参考",
    description: "查询历年院校录取分数、投档位次和批次信息，为高考志愿填报提供数据参考。",
    keywords: "分数线查询,投档线,录取位次,高考分数,一分一段",
    canonicalPath: "/data/scores",
    robots: "index,follow",
    ogType: "website",
    schema: [{ kind: "collection" }, { kind: "breadcrumbs" }],
  },
  "/data/policies": {
    title: "招生政策库 — 高考政策与招生规则查询",
    description: "聚合高考招生政策、选科要求、加分政策和批次规则，帮助考生理解填报要求。",
    keywords: "招生政策,高考政策,加分政策,选科要求,招生计划",
    canonicalPath: "/data/policies",
    robots: "index,follow",
    ogType: "website",
    schema: [{ kind: "collection" }, { kind: "breadcrumbs" }],
  },
  "/profile": {
    title: "个人中心 — 管理志愿方案和账户信息",
    description: "查看个人信息、我的方案、我的收藏、消息中心和会员权益。",
    keywords: "个人中心,我的方案,我的收藏,志愿管理",
    canonicalPath: "/profile",
    robots: "noindex,follow",
    ogType: "website",
    schema: [{ kind: "webpage" }],
  },
  "/profile/plans": {
    title: "我的方案 — 管理已生成的志愿方案",
    description: "集中查看、管理和导出AI生成的高考志愿方案。",
    keywords: "我的方案,志愿方案管理,方案导出",
    canonicalPath: "/profile/plans",
    robots: "noindex,follow",
    ogType: "website",
    schema: [{ kind: "webpage" }],
  },
  "/profile/favorites": {
    title: "我的收藏 — 收藏院校、专业和政策",
    description: "查看已收藏的院校、专业和政策内容，便于填报前集中比较。",
    keywords: "我的收藏,收藏院校,收藏专业,收藏政策",
    canonicalPath: "/profile/favorites",
    robots: "noindex,follow",
    ogType: "website",
    schema: [{ kind: "webpage" }],
  },
  "/profile/messages": {
    title: "消息中心 — 查看填报提醒和系统通知",
    description: "查看成绩公布、政策更新、方案优化和系统通知等消息。",
    keywords: "消息中心,高考提醒,系统通知,填报提醒",
    canonicalPath: "/profile/messages",
    robots: "noindex,follow",
    ogType: "website",
    schema: [{ kind: "webpage" }],
  },
  "/membership": {
    title: "会员中心 — 对比免费与VIP权益",
    description: "查看免费版和VIP会员的AI方案生成、风险检测、深度答疑和导出权益差异。",
    keywords: "会员中心,VIP,高考志愿会员,权益对比",
    canonicalPath: "/membership",
    robots: "index,follow",
    ogType: "website",
    schema: [{ kind: "webpage" }, { kind: "breadcrumbs" }],
  },
  "/gaokao-news": {
    title: "高考资讯中心 — 政策、院校、专业和录取动态",
    description: "浏览高考政策解读、院校动态、专业洞察、填报攻略和录取信息。",
    keywords: "高考资讯,政策解读,院校动态,专业洞察,录取动态",
    canonicalPath: "/gaokao-news",
    robots: "index,follow",
    ogType: "website",
    schema: [{ kind: "collection" }, { kind: "breadcrumbs" }],
  },
  "/score-query": {
    title: "高考分数查询地址 — 官方成绩查询渠道",
    description: "汇总各省高考成绩查询时间、考试院官网、电话、微信和APP入口。",
    keywords: "高考分数查询,成绩查询地址,教育考试院,查分入口",
    canonicalPath: "/score-query",
    robots: "index,follow",
    ogType: "website",
    schema: [{ kind: "webpage" }, { kind: "breadcrumbs" }],
  },
  "/pre-enrollment": {
    title: "入学前指南 — 跨区域大学生活准备",
    description: "按东北、华北、华东、华中、华南、西南、西北区域查看气候、饮食、交通和高校生活攻略。",
    keywords: "入学指南,大学新生,开学准备,跨省上大学,新生攻略",
    canonicalPath: "/pre-enrollment",
    robots: "index,follow",
    ogType: "website",
    schema: [{ kind: "webpage" }, { kind: "breadcrumbs" }],
  },
  "/help": {
    title: "帮助中心 — 常见问题与使用指南",
    description: "查看AI志愿填报、数据来源、会员权益、方案管理和平台使用常见问题。",
    keywords: "帮助中心,使用指南,常见问题,AI志愿填报帮助",
    canonicalPath: "/help",
    robots: "index,follow",
    ogType: "website",
    schema: [{ kind: "faq" }, { kind: "breadcrumbs" }],
  },
  "/disclaimer": {
    title: "免责声明 — AI推荐仅供辅助参考",
    description: "了解平台数据、AI分析结果、政策变动和最终志愿填报责任的免责声明。",
    keywords: "免责声明,高考志愿风险,AI推荐声明",
    canonicalPath: "/disclaimer",
    robots: "index,follow",
    ogType: "website",
    schema: [{ kind: "webpage" }, { kind: "breadcrumbs" }],
  },
  "/privacy": {
    title: "隐私政策 — 个人信息收集与保护说明",
    description: "了解平台如何收集、使用、存储和保护个人信息与填报数据。",
    keywords: "隐私政策,个人信息保护,数据安全",
    canonicalPath: "/privacy",
    robots: "index,follow",
    ogType: "website",
    schema: [{ kind: "webpage" }, { kind: "breadcrumbs" }],
  },
  "/terms": {
    title: "用户协议 — 平台服务与使用规范",
    description: "了解智选志愿服务范围、账户安全、使用规范、知识产权和免责条款。",
    keywords: "用户协议,服务条款,使用规范",
    canonicalPath: "/terms",
    robots: "index,follow",
    ogType: "website",
    schema: [{ kind: "webpage" }, { kind: "breadcrumbs" }],
  },
  "/plan/:id": {
    title: "方案详情 — 查看志愿方案明细",
    description: "查看志愿方案中的冲刺、稳妥、保底、兜底院校专业明细、录取概率和风险提示。",
    keywords: "方案详情,志愿方案,录取概率,风险提示",
    canonicalPath: "/profile/plans",
    robots: "noindex,follow",
    ogType: "website",
    schema: [{ kind: "webpage" }],
  },
  "*": {
    title: "页面未找到 — 智选志愿",
    description: "你访问的页面不存在，请返回智选志愿首页继续使用AI志愿填报服务。",
    keywords: "404,页面未找到,智选志愿",
    canonicalPath: "/404",
    robots: "noindex,follow",
    ogType: "website",
    schema: [{ kind: "webpage" }],
  },
};

export function getRouteMeta(pathname: string): RouteMeta {
  if (pathname.startsWith("/plan/")) return routeMeta["/plan/:id"];
  return routeMeta[pathname] ?? routeMeta["*"];
}
